import { CUSTOMER_NAME_FIELD } from '../type_name'
import { VSpacer } from 'vuetify/lib'
import CustomerUtil from '@/views/components/customer/libs/util';
export default {
    name: CUSTOMER_NAME_FIELD,
    props: {
        field: {
            type: Object,
        },
        value: {
            type: Object
        }
    },
    data() {
        return {
            customer: {}
        }
    },
    created() {
        this.init()
    },
    methods: {
        // 生成 VSpacer
        setVSpacer(h) {
            if (this.vSpacer) {
                return this.vSpacer
            }
            return this.vSpacer = h(VSpacer)
        },
        async init() {
            this.customer = await CustomerUtil.briefInfo(this.value[this.field.key]) || {};
        }
    },
    render(h) {
        const { label, valueRender } = this.field
        let value = null
        if (valueRender) {
            value = valueRender({field:this.field, value:this.value})
        } else {
            value = this.customer.account
        } 
        return h('div', {
            style: {
                display: 'flex',
                width: '100%'
            }
        }, [
            h('span', {
                style:{
                    'white-space':'nowrap',
                    'margin-right': '10px'
                }
            }, label),
            this.setVSpacer(h),
            h('span', {}, value)
        ])
    }
}